import * as ko from "knockout";
import * as mapping from "knockout.mapping";
import * as $ from "jquery";
import { SubscriptionDetail } from "../../Models/NewspaperRequestModels/subscriptionDetail";

class NewspaperRequestFullTableViewModel {
    SubscriptionDetails: KnockoutObservableArray<SubscriptionDetail>;
    OriginalRecipient: string;
    OriginalQuantity: number;
    OrderTypeDropDownOptions: any;

    constructor(params: any) {
        this.SubscriptionDetails = params.SubscriptionDetails;
        this.OrderTypeDropDownOptions = params.OrderTypesDropDownOptions;

        //console.log(JSON.parse(JSON.stringify(ko.toJS(params))));
        //console.log(JSON.parse(JSON.stringify(ko.toJS(this.SubscriptionDetails))));
    }

    edit(subscriptionDetail: SubscriptionDetail): void {
        this.OriginalRecipient = subscriptionDetail.RecipientName();
        this.OriginalQuantity = subscriptionDetail.ResultQuantity();
        subscriptionDetail.IsEditable(true);
    }

    save(parents: any, subscriptionDetail: SubscriptionDetail): void {

        let mappingOption = {
            'ignore': ["IsEditable", "IsValidItem"]
        }
        let dataToServer = JSON.stringify(mapping.toJS(subscriptionDetail, mappingOption));

        $.ajax({
            method: "POST",
            url: "NewspaperRequest/SavePaper",
            data: { "paperToSave": dataToServer }
        })
            .done((response) => {
                parents[3].errorVisible(false);
                parents[3].notificationVisible(false);
                if (typeof response['error'] !== 'undefined'
                    && response['error'] != null
                    && response['error'] != undefined) {

                    parents[3].errorVisible(true);
                    parents[3].errorMessage(response['error']);

                    subscriptionDetail.RecipientName(this.OriginalRecipient);
                    subscriptionDetail.ModifiedQuantity(this.OriginalQuantity);
                }
            })

            .fail((e) => {
                parents[3].errorVisible(true);
                parents[3].errorMessage("A tételt nem sikerült hozzáadni. Kérjük próbálja meg újra.");

                subscriptionDetail.RecipientName(this.OriginalRecipient);
                subscriptionDetail.ModifiedQuantity(this.OriginalQuantity);
            })
            .always(() => {
                subscriptionDetail.IsEditable(false);

                $.ajax({
                    method: "POST",
                    url: "NewspaperRequest/GetFramePrice",
                    data: {}
                })
                    .done((response) => {
                        if (typeof response['data'] !== 'undefined'
                            && response['data'] != null
                            && response['data'] != undefined) {

                            $('#framePrice').text(response['data']);
                        }
                    })

                    .fail((e) => {

                    });
            });
    }

    undoRecipientModify(newsPaper: SubscriptionDetail): void {
        newsPaper.RecipientName(this.OriginalRecipient);
    }

    undoQuantityModify(newsPaper: SubscriptionDetail): void {
        newsPaper.ModifiedQuantity(this.OriginalQuantity);
    }

    delete(parents: any, subscriptionDetail: SubscriptionDetail, event: any): void {
        parents[2].deletedItem().id(subscriptionDetail.Id());
        parents[2].deletedItem().siteId(subscriptionDetail.AddressId());
        parents[2].deletedItem().paperName(subscriptionDetail.NewspaperName());
        parents[2].deletedItem().recipient(subscriptionDetail.RecipientName());
        $("#ef-modal-delete").modal("show");
    }
}

export class NewspaperRequestFullTableComponent {
    constructor() {
        return {
            viewModel: NewspaperRequestFullTableViewModel,
            template: require("text-loader!./newspaperRequestFullTableView.html")
        }
    }
}